/**
 * Centralized <title> construction (SEO audit ticket C8).
 *
 * Every public page title must follow the "specific part | AIRspirit" suffix
 * convention so the page's promise stays visible first in truncated search
 * result snippets (~60 chars). Build titles through this helper instead of
 * writing the full string (brand included) in each view/route.
 */
export const BRAND_NAME = 'AIRspirit'

export function buildTitle(specific) {
  if (!specific) return BRAND_NAME
  return `${specific} | ${BRAND_NAME}`
}
